import { Spacer, SpacerStyles } from "@iewcasia/Components/Spacer";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

const enum fields {
    height = "height",
    heightMobile = "heightMobile",

    displayHeight = "Size for desktop",
    displayHeightMobile = "Size for mobile",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.height]: number;
        [fields.heightMobile]: number;
    };
}

export type Props = OwnProps;

export const spacerWidgetStyles: SpacerStyles = {};

export const styles = spacerWidgetStyles;

export const SpacerWidget = ({ fields: { heightMobile, height } }: Props) => {
    return <Spacer height={height} heightMobile={heightMobile} extendedStyles={styles} />;
};

const widgetModule: WidgetModule = {
    component: SpacerWidget,
    definition: {
        displayName: "Spacer",
        group: "Verndale Box" as any,
        icon: "up-right-and-down-left-from-center",
        fieldDefinitions: [
            {
                name: fields.height,
                displayName: fields.displayHeight,
                editorTemplate: "IntegerField",
                defaultValue: 20,
                min: 0,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.heightMobile,
                displayName: fields.displayHeightMobile,
                editorTemplate: "IntegerField",
                defaultValue: 20,
                min: 0,
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
